// Example of what might be inside aws-exports.js (simplified)
const outputs = {
  Auth: {
    userPoolId: 'us-east-2_MknsnE2ek', // Your Cognito User Pool ID
    userPoolWebClientId: '6t9gu9i5avd7rilb7p32h4suiq', // Your Cognito User Pool App Client ID
    identityPoolId: 'us-east-2:3ff303eb-8521-4045-b03b-b4ef981125bf', // Optional: if you have an Identity Pool
    region: 'us-east-2', // REQUIRED - Amazon Cognito Region
    oauth: {}, // <-- Defina um objeto OAuth vazio aqui
  },
  // Other categories like API, Storage, etc., will also be here
  API: { /* ... */ },
  Storage: { 
    AWSS3: {
      bucket: "portal-fanttech-shapefile-bucket",
      region: "us-east-2"
    }
  },
};

export default outputs;